<template>
  <div>
    <InputGroup icon="icontel" placeholder="请输入手机号" v-model="mobile"></InputGroup>
    <InputGroup placeholder="请输入验证码" v-model="code">
      <div class="code-btn" @click="sendCode" v-show="verification">{{sendText}}</div>
      <div class="code-btn not" v-show="!verification">重新发送({{timer}})</div>
    </InputGroup>
  </div>
</template>

<script>
import InputGroup from "@/components/layout/InputGroup.vue";
export default {
  name: "CodeInputGroup",
  components: { InputGroup },
  props: {},
  data() {
    return {
      mobile: "",
      code: "",
      verification: true,
      sendText: "获取验证码",
      timer: 60,
      auth_timer: ""
    };
  },
  watch: {
    mobile(val) {
      this.$emit("getTelPhone", val);
      this.$emit("getInputError", this.rightMobile.msg);
    },
    code(val) {
      this.$emit("getSmsCode", val);
    }
  },
  computed: {
    // 验证手机号
    rightMobile() {
      let res = {};
      if (!this.mobile) {
        res.status = false;
        res.msg = "请输入手机号";
      } else if (!/^1[345678]{1}\d{9}$/gi.test(this.mobile)) {
        res.status = false;
        res.msg = "手机号格式不正确";
      } else {
        res.status = true;
        res.msg=""
      }
      return res;
    }
  },
  methods: {
    sendCode() {
      if (!this.rightMobile.status) {
        return this.$emit("getInputError", this.rightMobile.msg);
      } else {
        this.$api.sms({ mobile: this.mobile, code: "login" }).then(res => {
          if (res.status) {
            this.verification = false;
            this.countDown(); // 执行验证码计时
          } else {
            this.$emit("getInputError", res.msg);
          }
        });
      }
    },
    countDown() {
      let auth_timer = setInterval(() => {
        // 定时器设置每秒递减
        this.timer--; // 递减时间
        if (this.timer <= 0) {
          this.verification = true; // 60s时间结束还原v-show状态并清除定时器
          this.timer = 60;
          clearInterval(auth_timer);
          this.sendText = "重新发送";
        }
      }, 1000);
    }
  },
  destroyed() {
    clearInterval(this.auth_timer);
  }
};
</script>
<style lang="scss" scoped>
.code-btn {
  width: 84px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  color: #ea4b49;
  font-weight: 400;
  border-left: 1px solid rgba(220, 220, 220, 1);
  cursor: pointer;
  &.not {
    color: #999;
  }
}
</style>